import React from 'react';
import { API_URL } from '../config';

const bannerImage = `${API_URL}/static/images/WelcomeBanner.png`

const Home = () => {
  return (
 
      <div className="h-100 w-100"
      style={{backgroundColor: 'rgba(255, 255, 255, 1)',
            padding: 0,
            margin: 0,
            border: 'none'
            }}>
        <h1 style={{color: '#4e54c8' }} className="text-center fontdiner-swanky-regular">Welcome to Lingoppia!</h1>
        <img 
          src={bannerImage}
          alt="Banner" 
          className="w-100"
          style={{
            maxHeight: '200px',  
            objectFit: 'cover'
          }}
        />
        <h2 style={{color: '#000000' }} className="text-center atma-bold">The Language Learning App</h2>
        <div class="container">
          <h5 class="mt-4">Current Offerings</h5>
          <div class="row row-cols-1 row-cols-md-3 g-4">
              <div class="col">
                  <div class="card h-100 rounded-0 custom-bg unkempt-regular text-white">
                      <div class="card-body">
                        <h5 class="card-title mt-3 fs-3">Vocabulary</h5>
                        <p class="card-text fs-5">Enjoy themed word lists in German, Spanish, French and Dutch</p>
                      </div>
                  </div>
              </div>
              <div class="col">
                  <div class="card h-100 rounded-0 bg-black unkempt-bold custom-text-primary">
                      <div class="card-body">
                        <h5 class="card-title mt-3 fs-3">Grammar Drills</h5>
                        <p class="card-text fs-5">Test your knowledge of verbs, prepositions, articles and more!</p>
                      </div>
                  </div>
              </div>
              <div class="col">
                  <div class="card h-100 rounded-0 custom-bg unkempt-regular text-black">
                      <div class="card-body">
                        <h5 class="card-title mt-3 fs-3">No ads! </h5>
                        <p class="card-text fs-5">Nothing to distract you while you learn!</p>
                      </div>
                  </div>
              </div>
          </div>
          <div>
            <p></p>
          </div>
          <div class="row row-cols-1 row-cols-md-3 g-4">
              <div class="col">
                  <div class="card h-100 rounded-0 custom-bg unkempt-regular text-black">
                      <div class="card-body">
                        <h5 class="card-title mt-3 fs-3">Low Cost</h5>
                        <p class="card-text fs-5">Only $2.99 per month</p>
                      </div>
                  </div>
              </div>
              <div class="col">
                  <div class="card h-100 rounded-0 custom-bg unkempt-regular text-white">
                      <div class="card-body">
                        <h5 class="card-title mt-3 fs-3">What's New?</h5>
                        <p class="card-text fs-5">Dutch! We just added Dutch!</p>
                      </div>
                  </div>
              </div>
              <div class="col">
                  <div class="card h-100 rounded-0 bg-black unkempt-bold custom-text-primary">
                      <div class="card-body">
                        <h5 class="card-title mt-3 fs-3"> </h5>
                        <p class="card-text fs-5">If only we spoke Hovitos...</p>
                      </div>
                  </div>
              </div>
          </div>
        </div>

      </div>

  );
};

export default Home;